export default {
  state: {
    layouts: {
      'symbols': [
        ['`','!','@','#','$','%'],
        ['^','&','*','(',')','_','+'],
        ['"','№',';','%',':','?', '<', '>', '/', '\\'],
        ['!!<langs:🌐>', '{enter}']
      ],
      'langs': [
        ['!!!<ru_RU_qwerty:RU>', '!!!<en_US_qwerty:En>'],
        ['!!!<numpad:123>', '!!!<symbols:!@#>']
      ],
      'numpad': [
        ['!!!{esc}', '!!!!{backspace}', '!!!!!(-)'],
        [1,2,3, '+'],
        [4,5,6, '*'],
        [7,8,9, '/'],
        ['!!!<langs:🌐>', '!!!!(0)', '!{enter}', '!!!!(.)']
      ],
      'ru_RU_qwerty': [
        ['{esc}', [1, '!'], [2, '"'], [3, '№'], [4, ';'], [5, '%'], [6, ':'], [7, '?'], [8,'*'], [9,'('], [0,')'], ['-', '_'], ['+', '='], '{backspace}'],
        ['!{tab}', 'й', 'ц', 'у', 'к', 'е', 'н', 'г', 'ш', 'щ', 'з', 'х', 'ъ', ['\\', '/']],
        ['!{caps}','ф','ы','в','а','п','р','о','л','д','ж','э', '{enter}'],
        ['!!{shift}','я','ч','с','м','и','т','ь','б','ю', ['.', ','], '!{shift}'],
        ['{ctrl}','{alt}', '!!!!!!!!!!{space}', '<langs:🌐>']
      ],
      'en_US_qwerty': [
        ['{esc}', [1, '!'], [2, '@'], [3, '#'], [4, '$'], [5, '%'], [6, '^'], [7, '&'], [8,'*'], [9,'('], [0,')'], ['-', '_'], ['+', '='], '{backspace}'],
        ['!{tab}', 'q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p', '[', ']', ['\\','|']],
        ['!{caps}','a','s','d','f','g','h','j','k','l',';','\'', '{enter}'],
        ['!!{shift}','z','x','c','v','b','n','m',[',','<'],['.', '>'], ['/', '?'], '!{shift}'],
        ['{ctrl}','{alt}', '!!!!!!!!!!{space}', '<langs:🌐>']
      ],

    },
    kbd_active: false,
    kbd_active_layout: 'numpad',
    kbd_active_input: undefined,
    kbd_active_input_container: undefined,
    kbd_options: {}
  },
  mutations:{
    setKbdActive(state, value) {
      state.kbd_active = value
    },
    setKbdLayout(state, value) {
      if (state.layouts[value]) {
        state.kbd_active_layout = value
      } else {
        console.error(`Unknown keyboard layout "${value}"`)
      }
    },
    setKeyboard(state, {input, input_container, layout, options}) {
      state.kbd_active_layout = layout
      state.kbd_active_input = input
      state.kbd_active_input_container = input_container
      if (options) {
        state.kbd_options = options
      }
      setTimeout(() => {
        state.kbd_active_input?.focus()
      }, 100)
    }
  },
  actions: {
    async hideKeyboard({ getters, commit }) {
      commit('setKbdActive', false)
      
      if (getters.kbd_active_input_container) {
        getters.kbd_active_input_container.classList.remove('vkb-active')
        getters.kbd_active_input_container.removeAttribute('style')
      }

      await new Promise(r => setTimeout(r, 10))

      if (getters.kbd_active_input) {
        getters.kbd_active_input.blur()
      }

      await commit('setKeyboard', {input: undefined, input_container: undefined, layout: 'numpad'})
    },
    async showKeyboard({ commit, dispatch }, {input, input_container, layout, options }) {
      await dispatch('hideKeyboard')
      await commit('setKeyboard', {input, input_container, layout, options})
      await commit('setKbdActive', true)
      
      input_container.classList.add('vkb-active')
      input_container.style.position = 'fixed'
      input_container.style.top = '50vh'
      input_container.style.width = '560px'
      input_container.style.padding = '20px 25px'
      input_container.style.transform = 'translateX(-50%) translateY(-87%)'
      input_container.style.left = '50vw'
      input_container.style.zIndex = '10000'
      input_container.style.backgroundColor = 'white'
      input_container.style.borderRadius = '8px'
      input_container.style.transition = 'all .2s ease-in-out'
      input_container.style.boxShadow = '4px 4px 25px 7px rgba(34, 60, 80, 0.2)'
  
    },
    inputFocus({ dispatch, getters }, evt){
      
      if (!getters.use_keyboard) {
        return
      }

      let input = evt.target

      if (input === getters.kbd_active_input ) {
        return
      }

      let input_container = input.closest('.v-text-field') || input
      
      let layout = ['phone', 'number'].includes(input.type) ? 'numpad' : input.getAttribute('kbd-layout') || getters.default_layout

      let capitalized = input.hasAttribute('kbd-capitalized')
      let no_caret = input.hasAttribute('kbd-no-caret')
      

      dispatch('showKeyboard', {input, input_container, layout, options: { capitalized, no_caret }} )

    }
  },
  getters: {
    kbd_active(state) {
      return state.kbd_active
    },
    kbd_active_layout(state) {
      return state.layouts[state.kbd_active_layout] 
    },
    kbd_active_input(state) {
      return state.kbd_active_input
    },
    kbd_active_input_container(state) {
      return state.kbd_active_input_container
    },
    use_keyboard() {
      let uri = window.location.search.substring(1); 
      let params = new URLSearchParams(uri);
      return ['1', 'true', 'yes', 'y'].includes(params.get("keyboard"))
    },
    default_layout(_, getters) {
      return `${getters.locale_metadata.Language}_qwerty`
    },
    kbd_options(state) {
      return state.kbd_options
    }
  }
}